module.exports = "<mat-sidenav-container>\n\n    <div id=\"fuse-main-content\">\n        <mat-progress-bar *ngIf=\"showLoadingBar\" class=\"loading-bar\" color=\"accent\" mode=\"indeterminate\"></mat-progress-bar>\n\n        <div id=\"wrapper\">\n\n            <div class=\"content-wrapper\">\n\n                <fuse-content></fuse-content>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main